import { Button, EnumDropdownItemVariant, type IDropdownItem, Typography } from 'shared/ui'
import { Select } from 'shared/ui/Select/Select'
import { LINK_DEVELOPER_HELP_GUIDE, LINK_DEVELOPER_API_DOCS_V2 } from 'shared/constants/links'
import styles from './styles.module.scss'

type IDeveloperDocsSelectProps = {
  className?: string
  placeholder?: string
}

const renderDocItemOption = (item: IDropdownItem<{ url: string }>) => (
  <Typography
    variant='body-md-regular'
    ariaLabel='docItemLabel'
    tag='div'
    color='var(--content-primary-primary)'
    className={styles.docItemOption}
  >
    {item.labelContent ?? item.label}
  </Typography>
)

const docItemOptionClassName = styles.docItemOptionRow

const DOC_ITEMS: IDropdownItem<{ url: string }>[] = [
  {
    id: 'help-guide',
    label: 'Help Guide',
    variant: EnumDropdownItemVariant.Custom,
    renderOption: renderDocItemOption,
    className: docItemOptionClassName,
    data: { url: LINK_DEVELOPER_HELP_GUIDE },
  },
  {
    id: 'api-docs-v2',
    label: 'API Docs (version 2.3)',
    variant: EnumDropdownItemVariant.Custom,
    renderOption: renderDocItemOption,
    className: docItemOptionClassName,
    data: { url: LINK_DEVELOPER_API_DOCS_V2 },
  },
]

export const DeveloperDocsSelect = ({
  className,
  placeholder = 'Documentation',
}: IDeveloperDocsSelectProps) => {
  const handleSelect = (item: IDropdownItem<{ url: string }>) => {
    const url = item.data?.url
    if (url) {
      window.open(url, '_blank', 'noopener,noreferrer')
    }
  }

  return (
    <div className={className} aria-label='Developer documentation links'>
      <Select
        type='default'
        variant='stroke'
        placeholder={placeholder}
        items={DOC_ITEMS}
        onSelect={handleSelect}
        dropdownProps={{
          ariaLabel: 'DeveloperDocsSelect',
          withSearch: false,
          placement: 'bottom-start',
          marginTop: 50,
          marginLeft: 1,
          width: 252,
          triggerComponent: (open) => (
            <Button
              icon='info'
              text={placeholder}
              contained='secondary'
              iconRight={open ? 'chevronUp' : 'chevronDown'}
              size='medium'
              active={open}
            />
          ),
        }}
      />
    </div>
  )
}
